module.exports = __webpack_public_path__ + "img/huxing4.eade6e2a.jpg";